export const SET_VISIBLE = 'finto/prodModeModal/visible';
